import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Dialog} from "primereact/dialog";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import LinearProgress from "@material-ui/core/LinearProgress";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import Divider from "@material-ui/core/Divider";

const ClientGSSView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    {props.messagesGrowl}
                    <Grid item xs={6}>
                        <TitlePage title="Mantenimiento \ Cliente GSS"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Buscar"
                            style={{'float': 'right'}}
                            onClick={props.getDataClientGSS}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <Button label="Agregar"
                                style={{'float': 'right'}}
                                onClick={props.openDialogAdd}
                                className="p-button-secondary"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.dataClientsGSS}
                            selectionMode="single"
                            onSelectionChange={props.handleSelectClient}
                            selection={props.clientSelected}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="idRelCliente" header="ID. Cliente"
                                    style={{textAlign: 'left', width: '15%'}}
                                    sortable={true}/>
                            <Column field="nomRel" header="Cliente GSS" style={{textAlign: 'left'}}
                                    sortable={true}/>
                            <Column header="Acciones" body={props.clientGSSOrderActionTemplate}
                                    style={{textAlign: 'right', width: '8em'}}/>
                        </DataTable>
                        {props.confirmationMsg}
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayDialog} modal={true}
                    header={props.dialogHeader}
                    onHide={props.onHideDialog} closable={false}
                    style={{width: "45%", textAlign: 'left',}}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-6 p-lg-6"
                         style={{padding: '.75em'}}>
                        <SubtitleLabel header="Id. Cliente" isBold={true}/>
                        {props.newClient ?
                            <InputText id="idRelCliente" keyfilter="pint"
                                       onChange={props.onChangeTextDialog}
                                       value={props.clientGSS.idRelCliente}
                                       placeholder="Ex. 9999"/> :
                            <div className="p-col-12">
                                <label> {props.clientGSS.idRelCliente} </label>
                            </div>
                        }
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6"
                         style={{padding: '.75em'}}>
                        <SubtitleLabel header="Cliente GSS" isBold={true}/>
                        <InputText id="nomRel" keyfilter={/^[a-zA-Z_áéíóúñ\s]*$/}
                                   onChange={props.onChangeTextDialog}
                                   value={props.clientGSS.nomRel}
                                   placeholder="Ex. Descripción"/>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
};

export default ClientGSSView;